import { ApisClient } from "@dpdgroupuk/mydpd-app";

export default new ApisClient({
  fallbackBaseUrl: process.env.REACT_APP_CT_API_URL,
});
